export const HintTemplateConstant = {
  OFFERS_TABLE: 'offers-table',
  OFFERS_PAGE: 'offers-page',
  GOALS_TABLE: 'goals-table',
  TARGETS_TABLE: 'targets-table',
  CLICKS_TABLE: 'clicks-table',
  AFFILIATES_TABLE: 'affiliates-table',
  AFFILIATES_TRACKERS_TABLE: 'affiliates-trackers-table',
  AFFILIATES_BILLING_TABLE: 'affiliates-billing-table',
  ADVERTISERS_TABLE: 'advertisers-table',
  NOTIFICATIONS_TABLE: 'notifications-table',
  INCIDENTS_TABLE: 'incidents-table',
  ACCESS_CONTROLS_AFFILIATES: 'access-controls-affiliates',
  ACCESS_CONTROLS_ADVERTISERS: 'access-controls-advertisers',
  CRM_SETTINGS: 'crm-settings',
  TRACKING_DOMAINS_TABLE: 'tracking-domains-table',
  TOKENS_TABLE: 'tokens-table',
  REPORTS_BUILDER: 'reports-builder',
  DRILLDOWN_REPORTS: 'drilldown-reports',
  COMPARING_ANALYTICS: 'comparing-analytics',
  PRESETS_LIST: 'presets-list',
  EVENTS_LOG: 'events-log',
  CRM_TERMS: 'crm_terms',
  DEALS_UPDATER: 'deals-updater',
  DEAL_HISTORY: 'deal-history',
  AFFILIATE_MANAGER: 'affiliate-manager',
  NOTIFICATIONS_SETTINGS: 'notification-settings',
  NOTIFICATIONS_SETTINGS_SLACK: 'notification-settings-slack',
  NOTIFICATIONS_SETTINGS_SLACK_EMPTY: 'notification-settings-slack-empty',
  CONVERSIONS: 'conversions',
  CRM_DOCUMENTS: 'crm-documents',
  ADVERTISER_BRAND: 'advertiser-brand',
  AFFILIATES_GROUP_TABLE: 'affiliates-group-table',
  GOAL_TYPES_TABLE: 'goal-types-table',
  PAYOUT_MODELS_TABLE: 'payout-models-table',
  REVENUE_MODELS_TABLE: 'revenue-models-table',
  OFFER_TRACKING_LINK: 'offer-tracking-link',
  BRAND_API_SETTINGS: 'BRAND_API_SETTINGS',
  EARNINGS: 'earning',
  FINANCE_INVOICES: 'finance-invoices',
  FINANCE_PAYMENTS: 'finance-payments',
  CONVERSION_PROFILE: 'conversion-profile',
  AFFILIATES_REQUESTS: 'affiliates-requests',
  ACCESS_TO_FREE_PARAMETERS: 'access-to-free-parameters',
  ADVERTISER_CONDITIONS: 'advertiser-conditions',
  GOALS: 'goals',
  OFFER_URLS: 'offer-urls',
  AFFILIATE_TRACKING_DOMAINS: 'affiliate-tracking-domains',
  AFFILIATE_ACCESS: 'affiliate-access',
  AFFILIATE_TRACKERS: 'affiliate-trackers',
  TARGETING: 'targeting',
  TRAFFIC_BACK_URLS: 'traffic-back-urls',
  RISK_MANAGEMENT: 'risk-management',
  CREATE_QUALIFICATION_ADD_FIELDS: 'create-qualification-add-fields',
  OFFER_DESCRIPTION_PRESETS_LIST: 'offer-description-presets-list',
  AFFILIATE_KYC: 'affiliate-kyc',
  AFFILIATE_KYC_ID: 'affiliate-kyc-id',
  CRM_QUESTIONS: 'crm-questions',
  CURRENCY_PROVIDER: 'currency-provider',
  PULLING_MAPPINGS: 'pulling-mappings',
  REFERRAL_BUSINESS_MODELS: 'referral-business-models',
  REFERRAL_PROGRAMS: 'referral-programs',
  AFFILIATE_INVOICE_CONSOLIDATION: 'affiliate-invoice-consolidation',
};
